import { render, staticRenderFns } from "./VarietyCreate.vue?vue&type=template&id=48285456&"
import script from "./VarietyCreate.vue?vue&type=script&lang=ts&"
export * from "./VarietyCreate.vue?vue&type=script&lang=ts&"
import style0 from "./VarietyCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports